import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let locationId = useDataValue({
    viewPath: props.viewPath,
    context: 'account',
    path: 'user.vaxiom_person.primary_location_id',
  })

  return {
    variables: {
      id: locationId,
    },
    pause: !locationId,
  }
}
